import React from 'react';

const Pagination = ({ currentPage, totalPages, handlePageChange }) => {

    const renderPagination = () => {
        const paginationItems = [];
        const lastPage = totalPages;
  
        
    
        // Очищення старих елементів
        const uniquePages = new Set();
    
        // Перша сторінка завжди відображається
        paginationItems.push(
            <li key="page-1" className={`page-item ${currentPage === 1 ? 'active' : ''}`}>
                <a className="page-link" href="#" onClick={() => handlePageChange(1)}>1</a>
            </li>
        );
        uniquePages.add(1);
    
       
        if (currentPage > 3 && !uniquePages.has('start-ellipsis')) {
            paginationItems.push(
                <li key="start-ellipsis" className="page-item disabled">
                    <a className="page-link">...</a>
                </li>
            );
            uniquePages.add('start-ellipsis');
        }
    
      
        for (let i = Math.max(2, currentPage - 1); i <= Math.min(currentPage + 1, lastPage - 1); i++) {
            if (!uniquePages.has(i)) { // Перевірка на унікальність
                paginationItems.push(
                    <li key={`page-${i}`} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                        <a className="page-link" onClick={() => handlePageChange(i)}>
                            {i}
                        </a>
                    </li>
                );
                uniquePages.add(i);
            }
        }
    
     
        if (currentPage < lastPage && !uniquePages.has(currentPage + 1)) {
            paginationItems.push(
                <li key={`page-${currentPage + 1}`} className="page-item">
                    <a className="page-link"  onClick={() => handlePageChange(currentPage + 1)}>
                        {currentPage + 1}
                    </a>
                </li>
            );
            uniquePages.add(currentPage + 1);
        }
    
    
        if (currentPage < lastPage - 1 && !uniquePages.has('end-ellipsis')) {
            paginationItems.push(
                <li key="end-ellipsis" className="page-item disabled">
                    <a className="page-link">...</a>
                </li>
            );
            uniquePages.add('end-ellipsis');
        }
    
        // Остання сторінка завжди відображається
        if (lastPage > 1 && !uniquePages.has(lastPage)) {
            paginationItems.push(
                <li key={`page-${lastPage}`} className={`page-item ${currentPage === lastPage ? 'active' : ''}`}>
                    <a className="page-link"  onClick={() => handlePageChange(lastPage)}>
                        {lastPage}
                    </a>
                </li>
            );
            uniquePages.add(lastPage);
        }
    
        return paginationItems;
    };


    return (
        <>
            {renderPagination()}
        </>
          
    );

}
export default Pagination;